@switch (searchType) {
  @case ('transparent') {
    <app-button
      btnType="icon"
      class="relative block shrink-0"
      [ariaLabel]="'filters' | translate"
      [matTooltip]="chipName || ('filters' | translate)"
      [disabled]="disabled"
      [matMenuTriggerFor]="company_menu"
      #matMenuTrigger="matMenuTrigger"
    >
      <app-icon>filter_list</app-icon>
      @if (hasFilter) {
        <span aria-hidden="true" class="absolute right-1 top-1 h-2 w-2 rounded-full bg-emerald-400"></span>
      }
    </app-button>
    <mat-menu #company_menu class="filter-mat-menu">
      <div (click)="$event.stopPropagation()" class="filter-menu">
        <div class="sidebar">
          <div class="top">
            <div class="title">{{ 'filters' | translate }}</div>
            <div [formGroup]="listFiltersForm" class="list crm-scroll">
              @for (filter of filters; track filter) {
                <div
                  (click)="changeCurrentFilter(filter)"
                  class="item"
                  [ngClass]="{ 'current-item': filter.id === currentFilter?.id && !isAction }"
                >
                  @if (isSettingsClicked && false) {
                    <app-icon class="icon-grab icon">menu </app-icon>
                  }
                  @if (!isSettingsClicked) {
                    <div class="item-text">
                      {{ filter.name }}
                    </div>
                  }
                  @if (isSettingsClicked) {
                    <app-hidden-input
                      [formControlName]="filter.id"
                      class="item-input"
                      [type]="'text'"
                      [inputHeight]="'36px'"
                    >
                    </app-hidden-input>
                  }
                  @if (isSettingsClicked) {
                    <app-icon class="icon" [matTooltip]="'delete_filter' | translate" (click)="onDeleteFilter(filter)">
                      clear
                    </app-icon>
                  }
                </div>
              }
              @if (isAddFilterClicked) {
                <app-text-field
                  placeholder="{{ 'field_name' | translate }}"
                  [formControl]="newFilterName"
                  class="p-1"
                  [autofocus]="true"
                >
                </app-text-field>
              }
            </div>
          </div>
          <div class="bottom">
            <div class="add-filter" [ngClass]="{ disabled: isAction }" (click)="onAddFilterClick()">
              <app-icon class="add-icon">add</app-icon>
              <div>{{ 'add_filter' | translate }}</div>
            </div>
            <app-icon [ngClass]="{ disabled: isAction }" (click)="onSettingsClick()" class="settings"
              >settings
            </app-icon>
          </div>
        </div>
        <div class="field-container">
          <div class="top">
            @if (filterForm) {
              <div class="list crm-scroll" [formGroup]="filterForm">
                @for (field of notSavedFields; track field) {
                  <div class="field">
                    @if (['text', 'uuid'].includes(field.type)) {
                      <div>
                        <app-text-field
                          [label]="createLabel(field.key)"
                          [formControl]="filterForm.controls[field.key]"
                        ></app-text-field>
                      </div>
                    }
                    @if (['price'].includes(field.type)) {
                      <div>
                        <app-price-field
                          [label]="createLabel(field.key)"
                          mask="separator.2"
                          [formControl]="filterForm.controls[field.key]"
                        ></app-price-field>
                      </div>
                    }
                    @if (['boolean'].includes(field.type)) {
                      <div>
                        <app-dropdown
                          [label]="createLabel(field.key)"
                          bindLabel="name"
                          bindValue="value"
                          [clearable]="true"
                          [items]="booleanItems"
                          [formControl]="filterForm.controls[field.key]"
                        >
                        </app-dropdown>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            <div class="buttons-fields">
              <span (click)="openModal()" class="add-field">{{ 'add_field' | translate }}</span>
              <span (click)="setDefaultFields()" class="default-fields">{{ 'default_fields' | translate }}</span>
            </div>
          </div>
          @if (!isAction) {
            <div class="bottom">
              @if (!Object.keys(currentFilter).length) {
                <app-button (onChangeClick)="onAddFilterClick()">{{ 'add' | translate }} </app-button>
              }
              @if (Object.keys(currentFilter).length) {
                <app-button (onChangeClick)="saveFilter()">{{ 'save' | translate }} </app-button>
              }
              <app-button (onChangeClick)="filterSearch()">{{ 'search' | translate }}</app-button>
              <app-button btnType="stroked" (onChangeClick)="filterReset()">{{ 'reset' | translate }}</app-button>
            </div>
          }
          @if (isAddFilterClicked) {
            <div class="bottom">
              <app-button (onChangeClick)="saveNewFilter()">{{ 'save' | translate }}</app-button>
              <app-button btnType="stroked" (onChangeClick)="cancelAddFilter()">{{ 'cancel' | translate }}</app-button>
            </div>
          }
          @if (isSettingsClicked) {
            <div class="bottom">
              <app-button (onChangeClick)="saveSettings()">{{ 'save' | translate }}</app-button>
              <app-button btnType="stroked" (onChangeClick)="cancelSettings()">{{ 'cancel' | translate }}</app-button>
            </div>
          }
        </div>
      </div>
    </mat-menu>
  }
}
